import { useState } from "react"
import "./Contact.css"

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    canCallWeekends: false,
  })

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(formData)
    // Here you would typically send the form data to a server
  }

  return (
    <section className="contact" id="contact">
      <div className="container">
        <h2 className="section-title">Contact us for more clarification & discussion for product development</h2>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-row">
            <input type="text" name="firstName" placeholder="First Name" required onChange={handleChange} />
            <input type="text" name="middleName" placeholder="Middle Name" onChange={handleChange} />
            <input type="text" name="lastName" placeholder="Last Name" required onChange={handleChange} />
          </div>
          <div className="form-row">
            <input type="email" name="email" placeholder="Email" required onChange={handleChange} />
            <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
          </div>
          <input
            type="text"
            name="subject"
            placeholder="Subject of your conversation"
            required
            onChange={handleChange}
          />
          <textarea name="message" placeholder="Type your message here" rows="5" onChange={handleChange}></textarea>
          <div className="form-row">
            <div className="file-input">
              <label htmlFor="attachment1">Add your Attachment 1</label>
              <input type="file" id="attachment1" name="attachment1" />
            </div>
            <div className="file-input">
              <label htmlFor="attachment2">Add your Attachment 2</label>
              <input type="file" id="attachment2" name="attachment2" />
            </div>
          </div>
          <div className="form-row">
            <label>
              <input
                type="checkbox"
                name="canCallWeekends"
                checked={formData.canCallWeekends}
                onChange={handleChange}
              />
              Can you happy to receive our Call Saturday, Sunday or other holidays
            </label>
          </div>
          <button type="submit" className="submit-button">
            SEND YOUR QUERY
          </button>
        </form>
        <div className="contact-info">
          <p>Call Us on : +91 8217782548</p>
        </div>
      </div>
    </section>
  )
}

export default Contact

